// extracted by mini-css-extract-plugin
export default {"customNavbar":"Navbar_customNavbar__3Pj+2","custContainer":"Navbar_custContainer__alKXY","navLink":"Navbar_navLink__sDYF1","navLinkActive":"Navbar_navLinkActive__iKDSJ"};